import TokenSender from "@legacy/@gedesco/reactcomponentsgdc-v2.token-manager/TokenSender"
import classNames from "classnames"
import Modal from "common/components/Modal/Modal"
import { AppContext } from "common/context/WithAppWrapper"
import useRedirectToExternalApp from "common/hooks/useRedirectToExternalApp"
import { ProgressBar } from "primereact/progressbar"
import { useContext } from "react"
import { KEYS, getValidUrl } from "./constants"
import "./mdfDialog.scss"

const MdfDialog = () => {
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type 'unknow...
  const { settings } = useContext(AppContext)

  const {
    showModal,
    handleAplications,
    progressValue,
    toggleShowModal,
    message,
    aplicationKey,
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  } = useRedirectToExternalApp()

  const handleRedirect = (appKey: $TSMigrationFixMe) => {
    handleAplications(appKey)
    toggleShowModal(!showModal)
  }

  return (
    <>
      <div className='relative tw-h-full'>
        <div className='tw-flex tw-justify-center tw-h-full tw-content-center tw-items-center'>
          <span
            role='button'
            tabIndex={0}
            className=''
            onClick={() => {
              handleRedirect(KEYS.GEFINTECH)
            }}
          >
            <img
              className={classNames([
                {
                  "app-logo": settings.title,
                },
              ])}
              alt='Logo de OPS'
              src={settings.ops}
            />
          </span>
        </div>

        <TokenSender
          message={message}
          targetUrl={import.meta.env.REACT_APP_ACCOUNTS}
        />
      </div>

      <Modal
        size='small'
        className='mercado-facturas-dialog'
        visible={showModal}
        onHide={toggleShowModal}
        closable={false}
        draggable={false}
        header={
          <div className='mercado-facturas-dialog__content-header'>
            <img
              alt='Logo de ERP'
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
              src={getValidUrl(settings)[aplicationKey].logo}
            />
          </div>
        }
      >
        <ProgressBar
          value={progressValue}
          showValue={false}
        />
      </Modal>
    </>
  )
}

export default MdfDialog
